import React from 'react';
import { Wrapper } from './style';

const WrapperUI: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default WrapperUI;
